// assets/gsap-init.js
gsap.registerPlugin(ScrollTrigger);

// Global GSAP defaults
gsap.defaults({
  //ease: 'power3.out',
  //duration: 1
});

// Any global animations or utility functions
const animateFrom = (elem, direction) => {
  direction = direction || 1;
  let x = 0,
      y = direction * 100;
      
  if(elem.classList.contains('reveal_fromLeft')) {
    x = -100;
    y = 0;
  } else if (elem.classList.contains('reveal_fromRight')) {
    x = 100;
    y = 0;
  }
  
  elem.style.transform = `translate(${x}px, ${y}px)`;
  elem.style.opacity = "0";
  
  gsap.fromTo(elem, {
    x: x,
    y: y,
    autoAlpha: 0
  }, {
    duration: 1.25,
    x: 0,
    y: 0,
    autoAlpha: 1,
    ease: "expo",
    overwrite: "auto"
  });
}